import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Nav } from 'react-bootstrap5';

export default function Pagination({
  coach, ratings, pageSize, eventKey,
}) {
  const firstPage = 0;
  const lastPage = parseInt(ratings.length / pageSize, 10) + (ratings.length % pageSize ? 1 : 0) - 1;

  const [activePage, setActivePage] = useState(firstPage);

  const prevPage = activePage > firstPage ? activePage - 1 : null;
  const nextPage = activePage < lastPage ? activePage + 1 : null;

  return (
    <div className="d-flex justify-content-end align-items-center">
      <div className="me-3" style={{ marginTop: '2px' }}>
        {(activePage * pageSize) + 1}
        &ndash;
        {Math.min((activePage + 1) * pageSize, ratings.length)}
        {' of '}
        {ratings.length}
      </div>

      <Nav>
        <Nav.Item key={`coach-${coach.id}-ratings-page-first`}>
          <Nav.Link
            eventKey={eventKey(firstPage)}
            onClick={() => setActivePage(firstPage)}
            className="icon-with-text"
          >
            <i className={`first-page-icon small-icon ${activePage === firstPage ? 'bg-gray-600' : ''}`} />
          </Nav.Link>
        </Nav.Item>

        <Nav.Item key={`coach-${coach.id}-ratings-page-prev`} className="ms-2">
          <Nav.Link
            eventKey={eventKey(prevPage)}
            onClick={() => setActivePage(prevPage)}
            className="icon-with-text"
          >
            <i className={`prev-page-icon small-icon ${prevPage === null ? 'bg-gray-600' : ''}`} />
          </Nav.Link>
        </Nav.Item>

        <Nav.Item key={`coach-${coach.id}-ratings-page-next`} className="ms-2">
          <Nav.Link
            eventKey={eventKey(nextPage)}
            onClick={() => setActivePage(nextPage)}
            className="icon-with-text"
          >
            <i className={`next-page-icon small-icon ${nextPage === null ? 'bg-gray-600' : ''}`} />
          </Nav.Link>
        </Nav.Item>

        <Nav.Item key={`coach-${coach.id}-ratings-page-last`} className="ms-2">
          <Nav.Link
            eventKey={eventKey(lastPage)}
            onClick={() => setActivePage(lastPage)}
            className="icon-with-text"
          >
            <i className={`last-page-icon small-icon ${activePage === lastPage ? 'bg-gray-600' : ''}`} />
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </div>
  );
}

Pagination.propTypes = {
  coach: PropTypes.object.isRequired,
  ratings: PropTypes.arrayOf(PropTypes.object).isRequired,
  pageSize: PropTypes.number.isRequired,
  eventKey: PropTypes.func.isRequired,
};
